import React from 'react';
import styled from '@emotion/styled';
import {
    color_shades_darkest,
    voicify_spark_light,
    voicify_spark_lightest
} from '../../../../../shared/constants/colors';

interface AppointmentSummaryMetricButtonProps {
    onClick: () => void;
}

const AppointmentSummaryMetricButton: React.FC<AppointmentSummaryMetricButtonProps> = ({
    onClick,
    children
}) => (
    <MetricButton
        type="button"
        onClick={onClick}
        aria-label="View outbound appointment success details"
        title="View appointment outcomes"
    >
        {children}
        <ViewHint>View breakdown <span aria-hidden="true">›</span></ViewHint>
    </MetricButton>
);

const MetricButton = styled.button`
    display: block;
    margin: -7px -9px -5px;
    padding: 7px 9px 5px;
    border: 0;
    border-radius: 10px;
    background: transparent;
    color: ${color_shades_darkest};
    cursor: pointer;
    font: inherit;
    text-align: right;
    transition: background 160ms ease, transform 160ms ease, box-shadow 160ms ease;

    &:hover {
        background: ${voicify_spark_lightest};
        transform: translateY(-1px);
        box-shadow: 0 5px 16px rgba(14, 133, 187, 0.09);
    }

    &:focus-visible {
        outline: 3px solid ${voicify_spark_light};
        outline-offset: 2px;
    }
`;

const ViewHint = styled.span`
    display: block;
    height: 0;
    overflow: hidden;
    color: #1ba5dc;
    font-size: 8px;
    font-weight: 700;
    line-height: 1.2;
    opacity: 0;
    transform: translateY(-2px);
    transition: height 160ms ease, margin 160ms ease, opacity 160ms ease, transform 160ms ease;

    ${MetricButton}:hover &,
    ${MetricButton}:focus-visible & {
        height: 10px;
        margin-top: 3px;
        opacity: 1;
        transform: translateY(0);
    }
`;

export default AppointmentSummaryMetricButton;
